































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getDefaultAloForgottenPass } from '@/models/alo/AloForgottenPass';

@Component({
  name: 'Login',  
})
export default class Login extends Vue {
  
  UserName = ''
  Password = ''
  Mail = ''
  dirtyEmail = false
  dirtyPwd = false
  forgotpass = false
  loading = false
  showMessageSuccess = false
  
  get authStatus() {
    switch(this.$store.myGetters.authStatus){
      case "AuthenticationProgress":
        return "Identification en cours"        
      case "AuthenticationSuccess":
        return "Identification réussie"        
      case "AuthenticationError":
        return "Erreur d'identification"        
      case "PassForgottenSuccess":
        return "Demande envoyée avec succès"
      case "PassForgottenProgress":
        return "Demande en cours"
      case "PassForgottenError":
        return "Erreur : Le compte et le mail ne correspondent pas"
      default:
        return ''        
    }
  }

  get redirectPath(){
      return this.$store.myGetters.redirectPath
  }

  
  beforeDestroy() {

  }
  
  @Watch("dirtyEmail")
  dirtyEmailChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.UserName.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  @Watch("dirtyPwd")
  dirtyPwdChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.Password.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }
  
  mounted(){
    this.hackToSolveAutoFillIssue()  
    this.$store.myActions.AUTH_RESET_STATUS()
  }

  hackToSolveAutoFillIssue(){
    let times = 0;
    const interval = setInterval(() => {
      times += 1
      if ((this.dirtyEmail && this.dirtyPwd) || times === 30) {
        clearInterval(interval)
      }
      else{
        this.dirtyEmail = !!document.querySelector('input[name="UserName"]:-webkit-autofill')
        this.dirtyPwd = !!document.querySelector('input[name="Password"]:-webkit-autofill')
      }
    }, 100)
  }
    
  submit() {     
    this.loading = true   
    if(this.forgotpass){
      const {UserName,Mail} = this    
      this.$store.myActions.AUTH_PASSWORD_REQUEST({ 
        ...getDefaultAloForgottenPass(),
        userLogin:UserName, userEmail:Mail 
      }).then(()=>{
        this.forgotpass = false
        this.showMessageSuccess = true
      })
      .finally(() => {
        this.loading = false
      })
    }
    else{
      const {UserName, Password} = this    
      this.$store.myActions.AUTH_REQUEST({ userLogin:UserName, userPass:Password }).then(() => {                    
        this.$router.push(this.redirectPath)
      }).finally(() => {
        this.loading = false
      })
    }
  }  

  forgotpassword() {
    this.$store.myActions.AUTH_RESET_STATUS()
    this.forgotpass = !this.forgotpass
  }
}
